/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export interface UserRating {
  isCheck24Customer: boolean;
  id: number;
  likeCount: number;
  rating: number;
  customerName: string;
  age: string;
  headline: string;
  summary: string;
  mainCommentBad: string;
  mainCommentGood: string;
  tourOperator: string;
  dateOfTravel: string;
  createdAt: string;
  traveledAs: UserRating_TraveledAs;
  mediaList: Media[];
}

export enum UserRating_TraveledAs {
  Unknown = "Unknown",
  Single = "Single",
  Pair = "Pair",
  Family = "Family",
  Friends = "Friends",
}

export function userRating_TraveledAsFromJSON(
  object: any
): UserRating_TraveledAs {
  switch (object) {
    case 0:
    case "Unknown":
      return UserRating_TraveledAs.Unknown;
    case 1:
    case "Single":
      return UserRating_TraveledAs.Single;
    case 2:
    case "Pair":
      return UserRating_TraveledAs.Pair;
    case 3:
    case "Family":
      return UserRating_TraveledAs.Family;
    case 4:
    case "Friends":
      return UserRating_TraveledAs.Friends;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum UserRating_TraveledAs"
      );
  }
}

export function userRating_TraveledAsToJSON(
  object: UserRating_TraveledAs
): string {
  switch (object) {
    case UserRating_TraveledAs.Unknown:
      return "Unknown";
    case UserRating_TraveledAs.Single:
      return "Single";
    case UserRating_TraveledAs.Pair:
      return "Pair";
    case UserRating_TraveledAs.Family:
      return "Family";
    case UserRating_TraveledAs.Friends:
      return "Friends";
    default:
      return "UNKNOWN";
  }
}

export function userRating_TraveledAsToNumber(
  object: UserRating_TraveledAs
): number {
  switch (object) {
    case UserRating_TraveledAs.Unknown:
      return 0;
    case UserRating_TraveledAs.Single:
      return 1;
    case UserRating_TraveledAs.Pair:
      return 2;
    case UserRating_TraveledAs.Family:
      return 3;
    case UserRating_TraveledAs.Friends:
      return 4;
    default:
      return 0;
  }
}

export interface TrustYouRating {
  amount: number;
  average: number;
  headline: string;
  text: string;
  category: string;
}

export interface RatingDetailCategory {
  category: string;
  ratingDetailList: RatingDetail[];
}

export interface RatingDetail {
  isTop: boolean;
  value: number;
  label: RatingDetail_Label;
  trend: RatingDetail_Trend;
}

export enum RatingDetail_Label {
  Unknown = "Unknown",
  Location = "Location",
  Hotel = "Hotel",
  Meals = "Meals",
  Service = "Service",
  Room = "Room",
  Family = "Family",
  Sport = "Sport",
  Pool = "Pool",
  Wellness = "Wellness",
  Beach = "Beach",
  Culture = "Culture",
  Infrastructure = "Infrastructure",
  SkiArea = "SkiArea",
  WinterSports = "WinterSports",
  Activities = "Activities",
}

export function ratingDetail_LabelFromJSON(object: any): RatingDetail_Label {
  switch (object) {
    case 0:
    case "Unknown":
      return RatingDetail_Label.Unknown;
    case 1:
    case "Location":
      return RatingDetail_Label.Location;
    case 2:
    case "Hotel":
      return RatingDetail_Label.Hotel;
    case 3:
    case "Meals":
      return RatingDetail_Label.Meals;
    case 4:
    case "Service":
      return RatingDetail_Label.Service;
    case 5:
    case "Room":
      return RatingDetail_Label.Room;
    case 6:
    case "Family":
      return RatingDetail_Label.Family;
    case 7:
    case "Sport":
      return RatingDetail_Label.Sport;
    case 8:
    case "Pool":
      return RatingDetail_Label.Pool;
    case 9:
    case "Wellness":
      return RatingDetail_Label.Wellness;
    case 10:
    case "Beach":
      return RatingDetail_Label.Beach;
    case 11:
    case "Culture":
      return RatingDetail_Label.Culture;
    case 12:
    case "Infrastructure":
      return RatingDetail_Label.Infrastructure;
    case 13:
    case "SkiArea":
      return RatingDetail_Label.SkiArea;
    case 14:
    case "WinterSports":
      return RatingDetail_Label.WinterSports;
    case 15:
    case "Activities":
      return RatingDetail_Label.Activities;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum RatingDetail_Label"
      );
  }
}

export function ratingDetail_LabelToJSON(object: RatingDetail_Label): string {
  switch (object) {
    case RatingDetail_Label.Unknown:
      return "Unknown";
    case RatingDetail_Label.Location:
      return "Location";
    case RatingDetail_Label.Hotel:
      return "Hotel";
    case RatingDetail_Label.Meals:
      return "Meals";
    case RatingDetail_Label.Service:
      return "Service";
    case RatingDetail_Label.Room:
      return "Room";
    case RatingDetail_Label.Family:
      return "Family";
    case RatingDetail_Label.Sport:
      return "Sport";
    case RatingDetail_Label.Pool:
      return "Pool";
    case RatingDetail_Label.Wellness:
      return "Wellness";
    case RatingDetail_Label.Beach:
      return "Beach";
    case RatingDetail_Label.Culture:
      return "Culture";
    case RatingDetail_Label.Infrastructure:
      return "Infrastructure";
    case RatingDetail_Label.SkiArea:
      return "SkiArea";
    case RatingDetail_Label.WinterSports:
      return "WinterSports";
    case RatingDetail_Label.Activities:
      return "Activities";
    default:
      return "UNKNOWN";
  }
}

export function ratingDetail_LabelToNumber(object: RatingDetail_Label): number {
  switch (object) {
    case RatingDetail_Label.Unknown:
      return 0;
    case RatingDetail_Label.Location:
      return 1;
    case RatingDetail_Label.Hotel:
      return 2;
    case RatingDetail_Label.Meals:
      return 3;
    case RatingDetail_Label.Service:
      return 4;
    case RatingDetail_Label.Room:
      return 5;
    case RatingDetail_Label.Family:
      return 6;
    case RatingDetail_Label.Sport:
      return 7;
    case RatingDetail_Label.Pool:
      return 8;
    case RatingDetail_Label.Wellness:
      return 9;
    case RatingDetail_Label.Beach:
      return 10;
    case RatingDetail_Label.Culture:
      return 11;
    case RatingDetail_Label.Infrastructure:
      return 12;
    case RatingDetail_Label.SkiArea:
      return 13;
    case RatingDetail_Label.WinterSports:
      return 14;
    case RatingDetail_Label.Activities:
      return 15;
    default:
      return 0;
  }
}

export enum RatingDetail_Trend {
  UnknownTrend = "UnknownTrend",
  Positive = "Positive",
  Negative = "Negative",
  NoTrend = "NoTrend",
}

export function ratingDetail_TrendFromJSON(object: any): RatingDetail_Trend {
  switch (object) {
    case 0:
    case "UnknownTrend":
      return RatingDetail_Trend.UnknownTrend;
    case 1:
    case "Positive":
      return RatingDetail_Trend.Positive;
    case 2:
    case "Negative":
      return RatingDetail_Trend.Negative;
    case 3:
    case "NoTrend":
      return RatingDetail_Trend.NoTrend;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum RatingDetail_Trend"
      );
  }
}

export function ratingDetail_TrendToJSON(object: RatingDetail_Trend): string {
  switch (object) {
    case RatingDetail_Trend.UnknownTrend:
      return "UnknownTrend";
    case RatingDetail_Trend.Positive:
      return "Positive";
    case RatingDetail_Trend.Negative:
      return "Negative";
    case RatingDetail_Trend.NoTrend:
      return "NoTrend";
    default:
      return "UNKNOWN";
  }
}

export function ratingDetail_TrendToNumber(object: RatingDetail_Trend): number {
  switch (object) {
    case RatingDetail_Trend.UnknownTrend:
      return 0;
    case RatingDetail_Trend.Positive:
      return 1;
    case RatingDetail_Trend.Negative:
      return 2;
    case RatingDetail_Trend.NoTrend:
      return 3;
    default:
      return 0;
  }
}

export interface Media {
  height: number;
  width: number;
  monthOfTravel: number;
  yearOfTravel: number;
  url: string;
  thumbnailUrl: string;
  subline: string;
}

function createBaseUserRating(): UserRating {
  return {
    isCheck24Customer: false,
    id: 0,
    likeCount: 0,
    rating: 0,
    customerName: "",
    age: "",
    headline: "",
    summary: "",
    mainCommentBad: "",
    mainCommentGood: "",
    tourOperator: "",
    dateOfTravel: "",
    createdAt: "",
    traveledAs: UserRating_TraveledAs.Unknown,
    mediaList: [],
  };
}

export const UserRating = {
  encode(
    message: UserRating,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isCheck24Customer === true) {
      writer.uint32(8).bool(message.isCheck24Customer);
    }
    if (message.id !== 0) {
      writer.uint32(16).uint32(message.id);
    }
    if (message.likeCount !== 0) {
      writer.uint32(120).uint32(message.likeCount);
    }
    if (message.rating !== 0) {
      writer.uint32(29).float(message.rating);
    }
    if (message.customerName !== "") {
      writer.uint32(34).string(message.customerName);
    }
    if (message.age !== "") {
      writer.uint32(42).string(message.age);
    }
    if (message.headline !== "") {
      writer.uint32(50).string(message.headline);
    }
    if (message.summary !== "") {
      writer.uint32(58).string(message.summary);
    }
    if (message.mainCommentBad !== "") {
      writer.uint32(106).string(message.mainCommentBad);
    }
    if (message.mainCommentGood !== "") {
      writer.uint32(114).string(message.mainCommentGood);
    }
    if (message.tourOperator !== "") {
      writer.uint32(66).string(message.tourOperator);
    }
    if (message.dateOfTravel !== "") {
      writer.uint32(74).string(message.dateOfTravel);
    }
    if (message.createdAt !== "") {
      writer.uint32(82).string(message.createdAt);
    }
    if (message.traveledAs !== UserRating_TraveledAs.Unknown) {
      writer
        .uint32(88)
        .int32(userRating_TraveledAsToNumber(message.traveledAs));
    }
    for (const v of message.mediaList) {
      Media.encode(v!, writer.uint32(98).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserRating {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserRating();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.isCheck24Customer = reader.bool();
          break;
        case 2:
          message.id = reader.uint32();
          break;
        case 15:
          message.likeCount = reader.uint32();
          break;
        case 3:
          message.rating = reader.float();
          break;
        case 4:
          message.customerName = reader.string();
          break;
        case 5:
          message.age = reader.string();
          break;
        case 6:
          message.headline = reader.string();
          break;
        case 7:
          message.summary = reader.string();
          break;
        case 13:
          message.mainCommentBad = reader.string();
          break;
        case 14:
          message.mainCommentGood = reader.string();
          break;
        case 8:
          message.tourOperator = reader.string();
          break;
        case 9:
          message.dateOfTravel = reader.string();
          break;
        case 10:
          message.createdAt = reader.string();
          break;
        case 11:
          message.traveledAs = userRating_TraveledAsFromJSON(reader.int32());
          break;
        case 12:
          message.mediaList.push(Media.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): UserRating {
    return {
      isCheck24Customer: isSet(object.isCheck24Customer)
        ? Boolean(object.isCheck24Customer)
        : false,
      id: isSet(object.id) ? Number(object.id) : 0,
      likeCount: isSet(object.likeCount) ? Number(object.likeCount) : 0,
      rating: isSet(object.rating) ? Number(object.rating) : 0,
      customerName: isSet(object.customerName)
        ? String(object.customerName)
        : "",
      age: isSet(object.age) ? String(object.age) : "",
      headline: isSet(object.headline) ? String(object.headline) : "",
      summary: isSet(object.summary) ? String(object.summary) : "",
      mainCommentBad: isSet(object.mainCommentBad)
        ? String(object.mainCommentBad)
        : "",
      mainCommentGood: isSet(object.mainCommentGood)
        ? String(object.mainCommentGood)
        : "",
      tourOperator: isSet(object.tourOperator)
        ? String(object.tourOperator)
        : "",
      dateOfTravel: isSet(object.dateOfTravel)
        ? String(object.dateOfTravel)
        : "",
      createdAt: isSet(object.createdAt) ? String(object.createdAt) : "",
      traveledAs: isSet(object.traveledAs)
        ? userRating_TraveledAsFromJSON(object.traveledAs)
        : UserRating_TraveledAs.Unknown,
      mediaList: Array.isArray(object?.mediaList)
        ? object.mediaList.map((e: any) => Media.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UserRating): unknown {
    const obj: any = {};
    message.isCheck24Customer !== undefined &&
      (obj.isCheck24Customer = message.isCheck24Customer);
    message.id !== undefined && (obj.id = Math.round(message.id));
    message.likeCount !== undefined &&
      (obj.likeCount = Math.round(message.likeCount));
    message.rating !== undefined && (obj.rating = message.rating);
    message.customerName !== undefined &&
      (obj.customerName = message.customerName);
    message.age !== undefined && (obj.age = message.age);
    message.headline !== undefined && (obj.headline = message.headline);
    message.summary !== undefined && (obj.summary = message.summary);
    message.mainCommentBad !== undefined &&
      (obj.mainCommentBad = message.mainCommentBad);
    message.mainCommentGood !== undefined &&
      (obj.mainCommentGood = message.mainCommentGood);
    message.tourOperator !== undefined &&
      (obj.tourOperator = message.tourOperator);
    message.dateOfTravel !== undefined &&
      (obj.dateOfTravel = message.dateOfTravel);
    message.createdAt !== undefined && (obj.createdAt = message.createdAt);
    message.traveledAs !== undefined &&
      (obj.traveledAs = userRating_TraveledAsToJSON(message.traveledAs));
    if (message.mediaList) {
      obj.mediaList = message.mediaList.map((e) =>
        e ? Media.toJSON(e) : undefined
      );
    } else {
      obj.mediaList = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<UserRating>): UserRating {
    const message = createBaseUserRating();
    message.isCheck24Customer = object.isCheck24Customer ?? false;
    message.id = object.id ?? 0;
    message.likeCount = object.likeCount ?? 0;
    message.rating = object.rating ?? 0;
    message.customerName = object.customerName ?? "";
    message.age = object.age ?? "";
    message.headline = object.headline ?? "";
    message.summary = object.summary ?? "";
    message.mainCommentBad = object.mainCommentBad ?? "";
    message.mainCommentGood = object.mainCommentGood ?? "";
    message.tourOperator = object.tourOperator ?? "";
    message.dateOfTravel = object.dateOfTravel ?? "";
    message.createdAt = object.createdAt ?? "";
    message.traveledAs = object.traveledAs ?? UserRating_TraveledAs.Unknown;
    message.mediaList =
      object.mediaList?.map((e) => Media.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTrustYouRating(): TrustYouRating {
  return { amount: 0, average: 0, headline: "", text: "", category: "" };
}

export const TrustYouRating = {
  encode(
    message: TrustYouRating,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.amount !== 0) {
      writer.uint32(24).uint32(message.amount);
    }
    if (message.average !== 0) {
      writer.uint32(37).float(message.average);
    }
    if (message.headline !== "") {
      writer.uint32(10).string(message.headline);
    }
    if (message.text !== "") {
      writer.uint32(18).string(message.text);
    }
    if (message.category !== "") {
      writer.uint32(42).string(message.category);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrustYouRating {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrustYouRating();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          message.amount = reader.uint32();
          break;
        case 4:
          message.average = reader.float();
          break;
        case 1:
          message.headline = reader.string();
          break;
        case 2:
          message.text = reader.string();
          break;
        case 5:
          message.category = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TrustYouRating {
    return {
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      average: isSet(object.average) ? Number(object.average) : 0,
      headline: isSet(object.headline) ? String(object.headline) : "",
      text: isSet(object.text) ? String(object.text) : "",
      category: isSet(object.category) ? String(object.category) : "",
    };
  },

  toJSON(message: TrustYouRating): unknown {
    const obj: any = {};
    message.amount !== undefined && (obj.amount = Math.round(message.amount));
    message.average !== undefined && (obj.average = message.average);
    message.headline !== undefined && (obj.headline = message.headline);
    message.text !== undefined && (obj.text = message.text);
    message.category !== undefined && (obj.category = message.category);
    return obj;
  },

  fromPartial(object: DeepPartial<TrustYouRating>): TrustYouRating {
    const message = createBaseTrustYouRating();
    message.amount = object.amount ?? 0;
    message.average = object.average ?? 0;
    message.headline = object.headline ?? "";
    message.text = object.text ?? "";
    message.category = object.category ?? "";
    return message;
  },
};

function createBaseRatingDetailCategory(): RatingDetailCategory {
  return { category: "", ratingDetailList: [] };
}

export const RatingDetailCategory = {
  encode(
    message: RatingDetailCategory,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.category !== "") {
      writer.uint32(10).string(message.category);
    }
    for (const v of message.ratingDetailList) {
      RatingDetail.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): RatingDetailCategory {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRatingDetailCategory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.category = reader.string();
          break;
        case 2:
          message.ratingDetailList.push(
            RatingDetail.decode(reader, reader.uint32())
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RatingDetailCategory {
    return {
      category: isSet(object.category) ? String(object.category) : "",
      ratingDetailList: Array.isArray(object?.ratingDetailList)
        ? object.ratingDetailList.map((e: any) => RatingDetail.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RatingDetailCategory): unknown {
    const obj: any = {};
    message.category !== undefined && (obj.category = message.category);
    if (message.ratingDetailList) {
      obj.ratingDetailList = message.ratingDetailList.map((e) =>
        e ? RatingDetail.toJSON(e) : undefined
      );
    } else {
      obj.ratingDetailList = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<RatingDetailCategory>): RatingDetailCategory {
    const message = createBaseRatingDetailCategory();
    message.category = object.category ?? "";
    message.ratingDetailList =
      object.ratingDetailList?.map((e) => RatingDetail.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRatingDetail(): RatingDetail {
  return {
    isTop: false,
    value: 0,
    label: RatingDetail_Label.Unknown,
    trend: RatingDetail_Trend.UnknownTrend,
  };
}

export const RatingDetail = {
  encode(
    message: RatingDetail,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isTop === true) {
      writer.uint32(8).bool(message.isTop);
    }
    if (message.value !== 0) {
      writer.uint32(21).float(message.value);
    }
    if (message.label !== RatingDetail_Label.Unknown) {
      writer.uint32(24).int32(ratingDetail_LabelToNumber(message.label));
    }
    if (message.trend !== RatingDetail_Trend.UnknownTrend) {
      writer.uint32(32).int32(ratingDetail_TrendToNumber(message.trend));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RatingDetail {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRatingDetail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.isTop = reader.bool();
          break;
        case 2:
          message.value = reader.float();
          break;
        case 3:
          message.label = ratingDetail_LabelFromJSON(reader.int32());
          break;
        case 4:
          message.trend = ratingDetail_TrendFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RatingDetail {
    return {
      isTop: isSet(object.isTop) ? Boolean(object.isTop) : false,
      value: isSet(object.value) ? Number(object.value) : 0,
      label: isSet(object.label)
        ? ratingDetail_LabelFromJSON(object.label)
        : RatingDetail_Label.Unknown,
      trend: isSet(object.trend)
        ? ratingDetail_TrendFromJSON(object.trend)
        : RatingDetail_Trend.UnknownTrend,
    };
  },

  toJSON(message: RatingDetail): unknown {
    const obj: any = {};
    message.isTop !== undefined && (obj.isTop = message.isTop);
    message.value !== undefined && (obj.value = message.value);
    message.label !== undefined &&
      (obj.label = ratingDetail_LabelToJSON(message.label));
    message.trend !== undefined &&
      (obj.trend = ratingDetail_TrendToJSON(message.trend));
    return obj;
  },

  fromPartial(object: DeepPartial<RatingDetail>): RatingDetail {
    const message = createBaseRatingDetail();
    message.isTop = object.isTop ?? false;
    message.value = object.value ?? 0;
    message.label = object.label ?? RatingDetail_Label.Unknown;
    message.trend = object.trend ?? RatingDetail_Trend.UnknownTrend;
    return message;
  },
};

function createBaseMedia(): Media {
  return {
    height: 0,
    width: 0,
    monthOfTravel: 0,
    yearOfTravel: 0,
    url: "",
    thumbnailUrl: "",
    subline: "",
  };
}

export const Media = {
  encode(message: Media, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.height !== 0) {
      writer.uint32(8).uint32(message.height);
    }
    if (message.width !== 0) {
      writer.uint32(16).uint32(message.width);
    }
    if (message.monthOfTravel !== 0) {
      writer.uint32(24).uint32(message.monthOfTravel);
    }
    if (message.yearOfTravel !== 0) {
      writer.uint32(32).uint32(message.yearOfTravel);
    }
    if (message.url !== "") {
      writer.uint32(42).string(message.url);
    }
    if (message.thumbnailUrl !== "") {
      writer.uint32(58).string(message.thumbnailUrl);
    }
    if (message.subline !== "") {
      writer.uint32(50).string(message.subline);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Media {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMedia();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.height = reader.uint32();
          break;
        case 2:
          message.width = reader.uint32();
          break;
        case 3:
          message.monthOfTravel = reader.uint32();
          break;
        case 4:
          message.yearOfTravel = reader.uint32();
          break;
        case 5:
          message.url = reader.string();
          break;
        case 7:
          message.thumbnailUrl = reader.string();
          break;
        case 6:
          message.subline = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): Media {
    return {
      height: isSet(object.height) ? Number(object.height) : 0,
      width: isSet(object.width) ? Number(object.width) : 0,
      monthOfTravel: isSet(object.monthOfTravel)
        ? Number(object.monthOfTravel)
        : 0,
      yearOfTravel: isSet(object.yearOfTravel)
        ? Number(object.yearOfTravel)
        : 0,
      url: isSet(object.url) ? String(object.url) : "",
      thumbnailUrl: isSet(object.thumbnailUrl)
        ? String(object.thumbnailUrl)
        : "",
      subline: isSet(object.subline) ? String(object.subline) : "",
    };
  },

  toJSON(message: Media): unknown {
    const obj: any = {};
    message.height !== undefined && (obj.height = Math.round(message.height));
    message.width !== undefined && (obj.width = Math.round(message.width));
    message.monthOfTravel !== undefined &&
      (obj.monthOfTravel = Math.round(message.monthOfTravel));
    message.yearOfTravel !== undefined &&
      (obj.yearOfTravel = Math.round(message.yearOfTravel));
    message.url !== undefined && (obj.url = message.url);
    message.thumbnailUrl !== undefined &&
      (obj.thumbnailUrl = message.thumbnailUrl);
    message.subline !== undefined && (obj.subline = message.subline);
    return obj;
  },

  fromPartial(object: DeepPartial<Media>): Media {
    const message = createBaseMedia();
    message.height = object.height ?? 0;
    message.width = object.width ?? 0;
    message.monthOfTravel = object.monthOfTravel ?? 0;
    message.yearOfTravel = object.yearOfTravel ?? 0;
    message.url = object.url ?? "";
    message.thumbnailUrl = object.thumbnailUrl ?? "";
    message.subline = object.subline ?? "";
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
